import type React from "react";
import { Table } from "./table";

interface GamesProps {
  heading: string;
  scores: {
    record: {
      name: string;
      info: string | number;
    }[];
  }[];
}

interface TableRowProps {
  records: {
    name: string;
    info: string | number;
    description?: string;
  }[];
  index?: number;
  isHeader?: boolean;
}

export const Games: React.FC<GamesProps> = ({ heading, scores }) => {
  const showTableRow: React.FC<TableRowProps> = ({ records = [], index, isHeader = false }) => {
    return (
      <tr className={isHeader ? "bg-[#ECECEC]" : index && index % 2 !== 0 ? "bg-thin-gray" : "bg-white"}>
        {records.map((record, i) => {
          return isHeader ? (
            <th
              key={`header-${record.name}-${i}`}
              className={`h-[44px] px-4 text-left whitespace-nowrap ${i !== 0 ? "border-l border-white" : ""}`}
            >
              <Table className="w-full h-full" name={record.name} />
            </th>
          ) : (
            <td
              key={`row-${record.info}-${i}`}
              className={`h-[44px] min-w-[120px] px-4 whitespace-nowrap border-b border-gray-200 
                ${i === 0 ? "border-l" : ""} border-r`}
            >
              <Table className="w-full h-full" name={record.info.toString()} />
            </td>
          );
        })}
      </tr>
    );
  };

  // const handleDownloadButton = () => {
  //   // download data from UI
  // }

  return (
    <div className="flex flex-col items-start gap-5 w-full pb-[23px]">
      {/* Heading */}
      <div className="px-[23px] flex items-center justify-between w-full">
        <h2 className="text-[22px] font-bold text-black">{heading}</h2>
        {/* <Button
          className="bg-white border-blue-600 border-2 border-solid rounded-[37.78px] text-blue-600 text-base font-semibold hover:bg-white hover:opacity-70"
          onClick={handleDownloadButton}
        >
          CSVダウンロード
        </Button> */}
      </div>
      {/* Scores */}
      <div className="px-6 w-full overflow-x-auto pb-8">
        <table className="w-full border-separate border-spacing-0">
          <thead>{showTableRow({ records: scores[0].record, isHeader: true })}</thead>
          <tbody>{scores.map((score, index) => showTableRow({ records: score.record, index }))}</tbody>
        </table>
      </div>
    </div>
  );
};
